import { Location } from "../../../integrated-client/models/Location";
import { StationOrLocationUI } from "../../../layout/ModalWindows/ModalWindowWrappers/SubRuleBusinessDataModalWrapper";

export type LocationsList = Array<Location>;

export class ResultsData {
  items: LocationsList;
  showMore: boolean;
  total?: number;
  allItems: Array<StationOrLocationUI>;

  constructor() {
    this.items = [];
    this.showMore = false;
    this.allItems = [];
  }
}
